import _ from "lodash";
import classNames from "classnames";
import { ADDRESS_MAP_COLOR_DPE } from "constants/address";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowRightOutlined } from "@ant-design/icons";

import { getDashboardURL } from "routes/constants";

interface Props {
  item: any;
  hideSelectButton?: boolean;
  isIframe?: boolean;
}

const AddressItem: React.FC<Props> = ({ item, hideSelectButton, isIframe }) => {
  const navigate = useNavigate();

  const handleSelect = (item: any) => {
    const refAdeme = _.get(item, "ref_ademe") || _.get(item, "ademe_id");
    if (isIframe) {
      // In iframe mode, open Kardino in a new tab
      window.open(`https://app.kardino.fr/projects/new/?code=${refAdeme}`, '_blank');
    } else {
      // Normal mode, navigate to dashboard (v2)
      navigate(getDashboardURL(refAdeme));
    }
  };

  return (
    <div
      className={classNames(
        "bg-[#F2F4F5] rounded-[10px] p-2 flex items-center justify-between gap-3",
      )}
    >
      <div className="flex gap-3">
        <div className="flex flex-col gap-1 justify-center">
          <p
            style={{
              background: ADDRESS_MAP_COLOR_DPE[_.get(item, "label")],
            }}
            className="2xl:min-w-[70px] rounded-full text-center font-semibold text-green-dark min-h-[29px] flex items-center justify-center"
          >
            {_.get(item, "label")}
          </p>
          {(_.get(item, "label_ges") || _.get(item, "date_etablissement_dpe")) && (
            <p
              style={{
                background: _.get(item, "date_etablissement_dpe") ? "#e5e7eb" : ADDRESS_MAP_COLOR_DPE[_.get(item, "label_ges")],
              }}
              className="2xl:min-w-[70px] rounded-full text-center font-semibold text-green-dark min-h-[29px] flex items-center justify-center px-2"
            >
              {_.get(item, "date_etablissement_dpe") ? (
                <span className="text-gray-500 text-xs font-normal">
                  {_.get(item, "date_etablissement_dpe")}
                </span>
              ) : (
                <>GES {_.get(item, "label_ges")}</>
              )}
            </p>
          )}
          {_.get(item, "date_dpe") && (
            <p className="py-1 px-2 rounded-full bg-[#0730341A] text-center font-medium text-[10px]">
              {_.get(item, "date_dpe")}
            </p>
          )}
        </div>
        <div className="">
          <p className="text-green-dark">
            N° Ademe :{" "}
            <span className="font-semibold">
              {_.get(item, "ademe_id")}
            </span>
          </p>

          {_.get(item, "housing_surface") && (
            <p className="text-green-dark">
              Surface :{" "}
              <span className="font-semibold">
                {_.get(item, "housing_surface")} m²
              </span>
            </p>
          )}

          {_.get(item, "type_batiment") && (
            <p className="text-green-dark">
              Type :{" "}
              <span className="font-semibold capitalize">
                {_.get(item, "type_batiment")}
              </span>
            </p>
          )}

          {_.get(item, "housing_add_compl") && (
            <p className="text-green-dark">
              Détails :{" "}
              <span className="font-semibold">
                {_.get(item, "housing_add_compl")}
              </span>
            </p>
          )}
        </div>
      </div>
      {!hideSelectButton && (
        <div className="flex flex-col items-center justify-center">
          <Button
            type="primary"
            className="flex items-center cursor-pointer justify-center gap-2 rounded-full min-h-[49px] border-0 w-full font-bold"
            onClick={() => handleSelect(item)}
          >
            <span className="!hidden xl:!inline">Sélectionnez</span>
            <ArrowRightOutlined />
          </Button>
        </div>
      )}
    </div>
  );
};

export default AddressItem;
